import Session from 'supertokens-auth-react/recipe/session';
import { fromPromise } from 'xstate';

export const getAuthToken = fromPromise(async () => {
  const token = await Session.getAccessToken();
  return { token };
});
